
  export const  descDarta =[
        {
            "qty":1,
             "id":22,
             "imgu":"https://images.asos-media.com/products/topman-varsity-print-shirt-in-green/202425963-1-green?$n_240w$&wid=168&fit=constrain",
             "title":"ASOS DESIGN – Silberfarbener Edelstahl-Bandring mit Schlangen- und Kreuzmotiven",
             "price":9.99,
             "rating":3.2
            },
            {
             "qty":1,
             "id":23,
              "imgu":"https://images.asos-media.com/products/hugo-ebor-sheer-logo-short-sleeve-shirt-in-white/202584045-1-white?$n_240w$&wid=168&fit=constrain",
              "title":"ASOS DESIGN – Silberner Ring aus Edelstahl mit römischen Zahlen",
              "price":9.99,
              "rating":4.5
            },
            {
             "qty":1,
             "id":24,
             "imgu":"https://images.asos-media.com/products/asos-design-boxy-oversized-shirt-in-bright-spray-paint-print/202648256-1-multi?$n_240w$&wid=168&fit=constrain",
             "title":"ASOS DESIGN – Halskette aus Sterlingsilber mit Damemotiv-Anhänger",
             "price":35.99,
             "rating":4.5
           },
           {
             "qty":1,
             "id":25,
             "imgu":"https://images.asos-media.com/products/huf-revere-collared-shirt-in-black-with-dice-print/202823366-1-black?$n_240w$&wid=168&fit=constrain",
             "title":"ASOS DESIGN 3mm figaro necklace with ace of spades pendant in silver finish",
             "price":7.99,
             "rating":4
           },
           
            {
            "qty":1,
             "id":26,
           "imgu":"https://images.asos-media.com/products/asos-design-halskette-mit-eispave-schmucksteinen/201980121-1-silver?$n_320w$&wid=317&fit=constrain",
             "title":"ASOS DESIGN necklace with ice pavé gemstones",
             "price":9.99 ,
             "rating":3.3
           },
           
           {
             "qty":1,
             "id":27,
             "imgu":"https://images.asos-media.com/products/asos-design-wickelring-in-skorpionform-aus-poliertem-sterlingsilber/200613559-1-silver?$n_320w$&wid=317&fit=constrain",
             "title":"ASOS DESIGN scorpion wrap ring in polished sterling silver",
             "price": 32.99,
             "rating":5
           },
           {
             "qty":1,
             "id":28,
             "imgu":"https://images.asos-media.com/products/asos-design-perlenarmband-in-schwarz-und-blau/201538289-1-black?$n_320w$&wid=317&fit=constrain",
             "title":"ASOS DESIGN beaded bracelet in black and blue",
             "price":9.99,
             "rating":3.1
           },
           {
             "qty":1,
             "id":29,
             "imgu":"https://images.asos-media.com/products/asos-design-ring-aus-sterlingsilber-mit-krake/200613345-1-silver?$n_320w$&wid=317&fit=constrain",
             "title":"ASOS DESIGN ring in sterling silver with octopus",
             "price":35.99 ,
             "rating":2
           },
           {
             "qty":1,
             "id":30,
             "imgu":"https://images.asos-media.com/products/asos-design-festival-dunne-body-chain-in-goldoptik/202605403-1-gold?$n_320w$&wid=317&fit=constrain",
             "title":"ASOS DESIGN Festival skinny body chain in gold finish",
             "price":24.99 ,
             "rating":4.9
           },
           {
             "qty":1,
             "id":31,
             "imgu":"https://images.asos-media.com/products/asos-design-festival-body-chain-mit-frohlichen-bunten-perlen/202605303-1-multi?$n_320w$&wid=317&fit=constrain",
             "title":"ASOS DESIGN festival body chain with fun colorful beads",
             "price": 35,
             "rating":3
           },
           {
             "qty":1,
             "id":32,
              "imgu":"https://images.asos-media.com/products/asos-design-siegelring-aus-sterlingsilber-mit-lowendesign-in-silber-poliert/200613568-1-silver?$n_320w$&wid=317&fit=constrain",
              "title":"ASOS DESIGN signet ring in sterling silver with a lion design in polished silver",
              "price": 49.88,
              "rating":4.5
            }
           ,{
            "qty":1,
             "id":33,
             "imgu":"https://images.asos-media.com/products/asos-design-2er-pack-halsketten-mit-kunstperlen-und-kreuz-anhanger-in-silber/201092021-1-silver?$n_320w$&wid=317&fit=constrain",
             "title":"ASOS DESIGN 2 pack faux pearl necklaces with cross pendant in silver",
             "price": 100,
             "rating":3.2
           },
           {
             "qty":1,
             "id":34,
             "imgu":"https://images.asos-media.com/products/asos-design-festival-sonnenbrillenkette-mit-buntem-ombre-design/202605324-1-multi?$n_320w$&wid=317&fit=constrain",
             "title":"ASOS DESIGN festival sunglasses chain in colorful ombré design",
             "price":12.88 ,
             "rating":5
           },
           {
             "qty":1,
             "id":35,
             "imgu":"https://images.asos-media.com/products/asos-design-ring-aus-sterlingsilber-im-krokodildesign/200613521-1-silver?$n_320w$&wid=317&fit=constrain",
             "title":"ASOS DESIGN ring in sterling silver with crocodile design",
             "price":33 ,
             "rating":4
           }
        ]
    
      